import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  ModalClose,
  ModalDialog,
  Typography,
} from "@mui/joy";

import { useModal } from "./useModal";

export default function TaskValidationFailed({
  message,
  title = "Cannot complete task yet",
}: {
  message: string;
  title?: string;
}) {
  const { close } = useModal();

  return (
    <ModalDialog>
      <ModalClose />
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography sx={{ maxWidth: 350 }}>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button color="neutral" variant="soft" onClick={close} sx={{ flex: 1 }}>
          Close
        </Button>
      </DialogActions>
    </ModalDialog>
  );
}
